import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import store from './store/store';
import EventList from './pages/EventList';
import EventDetails from './pages/EventDetails';
import PaymentStatusPage from './pages/PaymentStatusPage';
import CompletePendingPaymentPage from './pages/CompletePendingPaymentPage';
import DownloadPage from './pages/DownloadPage';
import SelfAttendancePage from './pages/SelfAttendancePage';
import { CssBaseline } from '@mui/material';

const EventListPage = () => <EventList />;

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<EventListPage />} />
          <Route path="/events/payment_complete/" element={<PaymentStatusPage status="complete" />} />
          <Route path="/events/payment_cancel/" element={<PaymentStatusPage status="cancel" />} />
          <Route path="/events/complete_payment/:purchaseRef" element={<CompletePendingPaymentPage />} />
          <Route path="/events/download/:transactionRef" element={<DownloadPage />} />
          <Route path="/self-attendance/:eventSlug/checkin" element={<SelfAttendancePage mode="checkin" />} />
          <Route path="/self-attendance/:eventSlug/checkout" element={<SelfAttendancePage mode="checkout" />} />
          <Route path="/events/:eventSlug" element={<EventDetails />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
